import React from 'react';
import clsx from 'clsx';
import {type UseFormReturn} from 'react-hook-form';
import {ReactHookFormTextField} from '@netx/core-components/Form/TextField';
import {composeClasses, styled, WithClasses} from '@netx/core-components/Theme';
import {AssetViewFormFieldLabel} from '../../locales';
import {IAssetView, type IAssetViewFormValues} from '../../schema';
import {
	ASSET_VIEW_MANAGER_NAME,
	assetViewManagerClasses,
	type AssetViewManagerClasses,
	getAssetViewManagerUtilityClass,
} from './assetViewManagerClasses';

type AssetViewManagerOwnerState = WithClasses<AssetViewManagerClasses>;

const useUtilityClasses = (state: AssetViewManagerOwnerState) => {
	const {classes} = state;
	const slots = {
		root: ['root'],
		inputWrapper: ['textFieldWrapper'],
	};
	return composeClasses(slots, getAssetViewManagerUtilityClass, classes);
};

const AssetViewManagerRoot = styled('div', {
	name: ASSET_VIEW_MANAGER_NAME,
	slot: 'Root',
})(({theme}) => ({
	display: 'flex',
	flexDirection: 'column',
	overflow: 'hidden',
	flex: '1 1 auto',
	minHeight: 0,
}));

// const InputWrapper = styled('div', {
// 	name: ASSET_VIEW_MANAGER_NAME,
// 	slot: 'InputWrapper',
// })(({theme}) => ({
// 	display: 'flex',
// 	flexDirection: 'column',
// 	padding: '8px 16px',
// }));

const ReactHookFormTextFieldStyled = styled(ReactHookFormTextField)(
	({theme}) => ({
		marginBottom: theme.spacing(1.5),
	}),
) as typeof ReactHookFormTextField;

export interface AssetViewManagerProps
	extends WithClasses<AssetViewManagerClasses> {
	assetView: IAssetView;
	form: UseFormReturn<IAssetViewFormValues>;
	loading?: boolean;
}

/**
 * `AssetViewManager` is a component for creating or editing system groups,
 * supporting user addition and removal with autocomplete functionality.
 */
export const AssetViewManager = ({
	classes: _classes,
	className,
	form,
	loading,
	...props
}: AssetViewManagerProps) => {
	const ownerState: AssetViewManagerOwnerState = {
		classes: _classes,
		className,
	};
	const classes = useUtilityClasses(ownerState);

	return (
		<AssetViewManagerRoot className={clsx(classes.root, className)} {...props}>
			<ReactHookFormTextFieldStyled
				control={form.control}
				disabled={loading}
				fullWidth
				label={AssetViewFormFieldLabel.NAME}
				name="name"
				required
				sx={{mb: 2}}
			/>

			<ReactHookFormTextFieldStyled
				control={form.control}
				disabled={loading}
				fullWidth
				label={AssetViewFormFieldLabel.DESCRIPTION}
				multiline
				name="description"
			/>
		</AssetViewManagerRoot>
	);
};
